import { Injectable } from '@angular/core';
import { HttpService } from '../modules/shared/http.service';
import { ClientReview, ClientReviewResponse, QuestionnaireItem, Responses, ResponsesSaveRequest, ReviewCRMSync, ReviewIdRequest } from './aml-modal';
import { Constant } from '../modules/shared/constants';
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs';
import { Utils } from '../modules/shared/utils';

@Injectable({
  providedIn: 'root'
})
export class AmlService {

  constructor(private _http:HttpService,) { }

   private role: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public role$: Observable<string> = this.role.asObservable();

   private repIDs: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public repIDs$: Observable< string[]> = this.repIDs.asObservable();

    setRepIDS(repIDs: string[]) {
   
    this.repIDs.next(repIDs);
  }

  setRole(role: string) {
  
    this.role.next(role);
  
}

//future use

 removeSessionData() {
  
    
sessionStorage.removeItem('applicationRole');
sessionStorage.removeItem('reviewGroups');
sessionStorage.removeItem('selectedGroups')

    }

setapplicationRole(role : string){
  sessionStorage.setItem('applicationRole', JSON.stringify(role));
}

getapplicationRole(){
  const storedData = sessionStorage.getItem('applicationRole');
  return storedData ? JSON.parse(storedData) : [];
}
 isPA: boolean = false;
  
  isDBD: boolean = false;
  isSuper: boolean = false;
  isAML: boolean = false;

setvisibility(role:any) :any {
   // Reset all role flags
      this.isAML = false;
      this.isDBD = false;
      this.isSuper = false;
      this.isPA = false;

      // Set role flags based on user.role
      switch (role) {
        case 'AML':
          this.isAML = true;
          break;
        case 'DBD':
          this.isDBD = true;
          break;
        case 'SUPER':
          this.isSuper = true;
          break;
        case 'PA':
          this.isPA = true;
          break;
        // Add more cases as needed
        default:
          // Optionally handle unknown roles
          break;
      }

  return {
    isAML: this.isAML,}
}


  getClientReviews(request: any): Observable<ClientReviewResponse> {
    return this._http.post<ClientReviewResponse>(Constant.uri.amlReviewURI, request,Utils.getHttpOptions());
  }

  

  getClientReviewsNoGroup(request: any): Observable<ClientReviewResponse> {
    return this._http.post<ClientReviewResponse>(Constant.uri.amlReviewURINoGroup, request,Utils.getHttpOptions());
  }

  saveDeleteGroup(request: any): Observable<any> {
    return this._http.post<any>(Constant.uri.amlSaveDeletGroupURI, request,Utils.getHttpOptions());
  } 
  getQuestionnaire(request: any): Observable<QuestionnaireItem[]> {
    return this._http.post<any>(Constant.uri.questionnaire, request, Utils.getHttpOptions());  
  }

  saveResponses(request: ResponsesSaveRequest): Observable<any> {
    return this._http.post<any>(Constant.uri.saveresponses, request, Utils.getHttpOptions());
  }

  downloadPdf(documentName: string): Observable<Blob> {

    return this._http.post(Constant.uri.downloadPDFNameURI, {'pdfName': documentName}, {responseType: 'blob',
        ...Utils.getHttpOptionsformdata()});
         
}

  //  generatePDF(request: ResponsesSaveRequest): Observable<Blob> {
  //   return this._http.post(Constant.uri.generatePDF, request, {
  //     ...Utils.getHttpOptions(),
  //     responseType: 'blob' as 'json'
  //   });
  // }

  //  generatefromhtml(request: { Html: string }): Observable<Blob> {
  //   return this._http.post(Constant.uri.generateFromHtml, request, {
  //     ...Utils.getHttpOptions(),
  //     responseType: 'blob' as 'json'
  //   });


    

    
  // }

//  generatefromhtmlNode(request: { Html: string }): Observable<Blob> {
//     return this._http.post('http://localhost:3000/generate-pdf', request, {
//       ...Utils.getHttpOptions(),
//       responseType: 'blob' as 'json'
//     });
//   }

 generatefromhtmlNode(request: any): Observable<Blob> {
    return this._http.post(Constant.uri.generatePDF, request, {
      ...Utils.getHttpOptions(),
      responseType: 'blob' as 'json'
    });
  }

getResponsesByReview(request: ReviewIdRequest): Observable<Responses[]> {
  return this._http.post<any>(
    Constant.uri.responsesbyreview,
    request,
    Utils.getHttpOptions()
  );
}

uploadPDF(pdfBlob: Blob,documentName:string): Observable<any> {
  const formData = new FormData();
  formData.append('file', pdfBlob,  documentName);
  return this._http.post(Constant.uri.uploadPDF, formData, Utils.getHttpOptionsformdata());
}

updatePeriodicClientCRMSync(payload: ReviewCRMSync): Observable<any>{
    return this._http.patch(Constant.uri.updatePeriodicClientCRMSync, payload, Utils.getHttpOptionsformdata());
}

}
